<template>
    <div class="divMain">
      <div id="divChart" ref="divChart">
        <div id="divDataInfo" ref="divDataInfo" v-if="showDataInfo" v-bind:style="{left: divInfoPath[0]+'px', top: divInfoPath[1]+'px'}">
          <div class="month">
            {{divInfoMonth}}
          </div>
          <div class="mappingWeekDay">{{divMappingWeekDay}}</div>
          <div class="value" v-html="divInfoValue">

          </div>
        </div>
      </div>
    </div>
</template>

<script>
import * as d3 from 'd3';
import * as moment from 'moment';

export default {
  name: "chartForecast",
  props: ['simpleMode', 'dataChartReal', 'dataChartForecast', 'isNeededShowLegend', 'customWidth', 'customHeight', 'mappingWeekDay'],
  data(){
    return {
      svg: undefined,
      margin: {top: 70, bottom: 45, left: 40, right: 22},
      width: this.customWidth == undefined ? 540 : this.customWidth, 
      height: this.customHeight == undefined ? 320 : this.customHeight,
      y: undefined,
      x: undefined,
      lineRealValue: undefined,
      lineForecastValue: undefined,
      currentFocusForecastValue: undefined,
      yTranslate: undefined,
      legend: undefined,
      lineCursor: undefined,

      divInfoMonth: undefined,
      divInfoValue: undefined,
      divMappingWeekDay: undefined,
      divInfoPath: [],
      showDataInfo: false,
    }
  },
  methods: { 
    initChartComponent(){
      this.svg = d3.select(this.$refs.divChart).append("svg")
        .attr("width", "100%")
        .attr("height", `${this.height}px`)
        .attr("viewBox", `0 0 ${this.width} ${this.height}`)
        .attr("perserveAspectRatio", "xMinYMid")
    
      this.x = d3.scalePoint().rangeRound([0, this.width - this.margin.left - this.margin.right])
      this.y = d3.scaleLinear().range([this.height - this.margin.top, 0])
      
      this.yTranslate = "translate("+`${0+this.margin.left} ${0 - this.margin.bottom + this.margin.top}`+")"
      this.svg.append("g")
        .attr("class", "axis axis--y")
        .attr("transform", this.yTranslate)
        
      .append("text")
        //.attr("transform", "rotate(-90)")
        .attr("y", -15)
        .attr("dy", "0.71em")
        .attr("fill", "#848484")
        .attr("font-family", "Noto Sans TC")
        .text(this.$i18n.t("ChartForecast.Visits"));

      this.svg.append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate("+`${this.margin.left} ${this.height - this.margin.bottom}`+")").append("text")
        .attr("x", `${this.width - this.margin.left - this.margin.right +2}`)
        .attr("y", `30`)
        .attr("fill", "#848484")
        .attr("text-anchor", "end")
        .attr("font-family", "Noto Sans TC")
        .text(this.$i18n.t("ChartForecast.YearWeek"));

      this.lineRealValue = d3.line()
        .x((d)=>{return this.x(d.yearWeek)})
        .y((d)=>{return this.y(d.realValue)})
      
      this.lineForecastValue = d3.line()
        .x((d)=>{return this.x(d.yearWeek)})
        .y((d)=>{return this.y(d[this.currentFocusForecastValue])})

      //Append Line for real
      this.svg.append("path").attr("class", "path path_real");

      //Append Line for external line
      for(let i=0;i<this.dataChartForecast.arrKey.length;i++)
        this.svg.append("path").attr("class", "path path_forecast path_"+this.dataChartForecast.arrKey[i]);

      //Legend
      if(this.isNeededShowLegend){
        this.legend = this.svg.append("g")
        .attr("transform", this.yTranslate);
        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 10).attr("y2", 10).attr("class", "path path_real")
        this.legend.append("text").text(this.$i18n.t("ChartForecast.History")).attr("x", 70).attr("y", 15).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC")

        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 30).attr("y2", 30).attr("class", "path path_forecast path_Ensemble")
        this.legend.append("text").text("Ensemble").attr("x", 70).attr("y", 35).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC").attr("class", "text text_forecast text_Ensemble")

        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 50).attr("y2", 50).attr("class", "path path_forecast path_ARIMA")
        this.legend.append("text").text("ARIMA").attr("x", 70).attr("y", 55).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC").attr("class", "text text_forecast text_ARIMA")

        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 70).attr("y2", 70).attr("class", "path path_forecast path_RF")
        this.legend.append("text").text("RF").attr("x", 70).attr("y", 75).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC").attr("class", "text text_forecast text_RF")

        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 90).attr("y2", 90).attr("class", "path path_forecast path_SVR")
        this.legend.append("text").text("SVR").attr("x", 70).attr("y", 95).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC").attr("class", "text text_forecast text_SVR")

        this.legend.append("line").attr("x1",30).attr("x2", 60).attr("y1", 110).attr("y2", 110).attr("class", "path path_forecast path_XGB")
        this.legend.append("text").text("XGB").attr("x", 70).attr("y", 115).attr("font-size", 13)
        .attr("font-family", "Noto Sans TC").attr("class", "text text_forecast text_XGB")

        
        this.legend.append("rect").attr("x",this.width - 60).attr("y", 0).attr("width", 10).attr("height", 10).attr("fill", "#28A745")
        this.legend.append("rect").attr("x",this.width - 60).attr("y", 20).attr("width", 10).attr("height", 10).attr("fill", "#007BFF")

        this.legend.append("text").text("XGB").attr("x",this.width - 65).attr("y", 10).attr("font-size", 13)
          .attr("font-family", "Noto Sans TC").attr("text-anchor", "end").html(`${this.$i18n.t('ChartForecast.HistoryData')}${this.$i18n.t("ChartForecast.DeadlineWeek")}`).attr("fill", "#848484")
        this.legend.append("text").text("XGB").attr("x",this.width - 65).attr("y", 30).attr("font-size", 13)
          .attr("font-family", "Noto Sans TC").attr("text-anchor", "end").html(`${this.$i18n.t('ChartForecast.ThisWeek')}`).attr("fill", "#848484")
      }

      //Mouse Line
      this.lineCursor = this.svg.append("path").attr("class", "lineCursor")
      
    },
    
    initXDomain(){
      let arrDomainArray = this.dataChartReal.map((d)=>{return d.yearWeek})
      let strNewestWeek = this.dataChartReal[this.dataChartReal.length-1].yearWeek
      let currentWeek = String((moment().year()*100+moment().week()));
      
      arrDomainArray = arrDomainArray.concat(this.dataChartForecast.map((d)=>{return d.yearWeek}))
      arrDomainArray.sort();
      
      this.x.domain(arrDomainArray)
      this.svg.selectAll(".axis--x")
        .call(
          d3.axisBottom(this.x).tickFormat((d, i)=>{
            return d.substring(4,6)
          })
        );

        this.svg.selectAll(".axis--x .tick text")
          .style("fill", function(d){
            if(d == strNewestWeek) return '#28a745'
            else if ( d == currentWeek ) return '#007bff'
          })
          .style("font-weight", function(d){
            if(d == strNewestWeek || d == currentWeek) return "bold"
          })
          .style("font-size", function(d){
            if(d == strNewestWeek || d == currentWeek) return "22px"
          });

        this.svg.selectAll(".axis--x .tick")
        .append("text")
        .attr("text-anchor", "middle")
        .attr("dy", ".35em")
        .attr("font-family", "Noto Sans TC")
        .attr("y", (d)=>{
          if(parseFloat(d.substring(4,6)) == 1) return '';
          if(d == strNewestWeek) return -30;
          if(d == currentWeek) return -16;
        })
        .html((d, i) => {
          if(i==0 || parseFloat(d.substring(4,6)) == 1 ) return d.substring(0, 4);
          // if(d == strNewestWeek) return "<tspan x='0' text-anchor='middle' dy='1em' y='-50'>"+this.$i18n.t("ChartForecast.HistoryData")+"</tspan><tspan x='0' text-anchor='middle' dy='1em'>"+this.$i18n.t("ChartForecast.DeadlineWeek")+"</tspan>"
          // if(d == currentWeek) return "<tspan x='0' text-anchor='middle' dy='1em'>"+this.$i18n.t("ChartForecast.ThisWeek")+"</tspan>"
          
        })
        .attr("class", (d, i)=>{
          if(i==0 || parseFloat(d.substring(4,6)) == 1 ) {
            return "year";
          }
        })
        .attr("dy", (d, i)=>{
          //Week 1 is in least data.
          if(parseInt(this.dataChartReal[this.dataChartReal.length-1].yearWeek.substring(4,6)) == 49 && parseFloat(d.substring(4,6)) == 1) return "2.6em"; 
          if(i==0 || parseFloat(d.substring(4,6)) == 1 ) return "2.1em";
          else if(d == strNewestWeek) return "-.3em";
        });
    },

    initYDomain(){
      let arrRealMin = d3.min(this.dataChartReal, (d)=>{return d.realValue})
      let arrRealMax = d3.max(this.dataChartReal, (d)=>{return d.realValue})
      let arrForecastMin = Infinity, arrForecastMax = 0;
      for(let i=0;i<this.dataChartForecast.length;i++){
        for(let j=0;j<this.dataChartForecast.arrKey.length;j++){
          if(this.dataChartForecast[i][this.dataChartForecast.arrKey[j]] > arrForecastMax) 
            arrForecastMax = this.dataChartForecast[i][this.dataChartForecast.arrKey[j]];
          if(this.dataChartForecast[i][this.dataChartForecast.arrKey[j]] < arrForecastMin) 
            arrForecastMin = this.dataChartForecast[i][this.dataChartForecast.arrKey[j]];
        }
      }

      let tenPercentValue = Math.abs(d3.max([arrRealMax, arrForecastMax]) - d3.min([arrRealMin, arrForecastMin])) / 10
      this.y.domain([d3.min([arrRealMin, arrForecastMin])-tenPercentValue, d3.max([arrRealMax, arrForecastMax])+tenPercentValue])

      //Update y axis
      this.svg.selectAll(".axis--y")
        .call(
          d3.axisLeft(this.y).ticks(10, "s")
        )
    },

    appendLastValueToEnsemble(){
      let firstObject = {yearWeek: this.dataChartReal[this.dataChartReal.length-1].yearWeek, Ensemble: this.dataChartReal[this.dataChartReal.length-1].realValue}
      if(this.customWidth == undefined) this.dataChartForecast.unshift(firstObject)
    },

    updateRealLine(){
      //Update Real Line
      this.svg.select(".path_real")
        .datum(this.dataChartReal)
        .attr("d", this.lineRealValue)
        .attr("transform", this.yTranslate);
    },

    updateForecastLine(){
      for(let i=0;i<this.dataChartForecast.arrKey.length;i++){
        this.currentFocusForecastValue = this.dataChartForecast.arrKey[i]
        this.drawObject = this.dataChartForecast.map((d)=>{if(d[this.currentFocusForecastValue] != undefined) return d;}).filter((d)=>{return d != undefined})

        this.svg.select(`.path_${this.currentFocusForecastValue}`)
          .datum(this.drawObject)
          .attr("d", this.lineForecastValue)
          .attr("transform", this.yTranslate);
      }
    },
    updateEnsembleCircle(){
      this.svg.selectAll(".circle_Ensemble").remove();
      this.svg.selectAll(".circle_Ensemble")
        .data(this.dataChartForecast)
        .enter()
        .append("circle")
        .attr("class", "circle_Ensemble")
        .attr("r", 5)
        .attr("cx", (d)=>{return this.x(d.yearWeek)})
        .attr("cy", (d)=>{return this.y(d.Ensemble)})
        .attr("transform", this.yTranslate);

      //Change first style
      this.svg.select(".circle_Ensemble").attr("class", "circle_Ensemble first")
      //this.svg.select(".circle_Ensemble:not(.first)")
      
    },
    updateMouseOverEvent(){
      let _this = this;
      let rectMouseOverReal = this.svg.selectAll(".rectMouseOverReal").data(this.dataChartReal).enter()
        .append("rect")
        .attr("class", "rectMouseOver rectMouseOverReal")
        .attr("x", (d, i)=>{
          if(i==0) return this.x(d.yearWeek)
          else return this.x(d.yearWeek)-this.x.step()/2
        })
        .attr("y", 0)
        .attr("width", (d, i)=>{
          if(i==0) return this.x.step()/2
          else return this.x.step()
        })
        .on("mouseover", (d)=>{
          this.lineCursor.style("opacity", 1);
          this.showDataInfo = true;
          
          if(this.$getCookie("language") == 'en'){
            _this.divInfoMonth = `${d.yearWeek.substring(0,4)} Week ${d.yearWeek.substring(4,6)}`;
            _this.divMappingWeekDay = _this.mappingWeekDay.find((d2)=>{return d2.yearWeek == d.yearWeek}).date;
            _this.divInfoValue = `History ${_this.getNumberofPeople(d.realValue)}`;
            _this.lineCursor.attr("d", `M${_this.x(d.yearWeek)+_this.margin.left} 0 V280`);
          }

          else{
            _this.divInfoMonth = `${d.yearWeek.substring(0,4)}年 ${d.yearWeek.substring(4,6)}週`;
            _this.divMappingWeekDay = _this.mappingWeekDay.find((d2)=>{return d2.yearWeek == d.yearWeek}).date;
            _this.divInfoValue = `歷史人次 ${_this.getNumberofPeople(d.realValue)}`;
            _this.lineCursor.attr("d", `M${_this.x(d.yearWeek)+_this.margin.left} 0 V280`);
          }
        })
        .on("mousemove", function(d){
          _this.divInfoPath = 
          [d3.event.pageX-(_this.$refs.divChart.getBoundingClientRect().x || _this.$refs.divChart.getBoundingClientRect().left)-window.pageXOffset+15, 
          d3.event.pageY-(_this.$refs.divChart.getBoundingClientRect().y || _this.$refs.divChart.getBoundingClientRect().top)-window.pageYOffset+15]

          if(_this.divInfoPath[1] + 80 > _this.$refs.divChart.offsetHeight){
            _this.divInfoPath[1] -= 80
          }
        });

      let rectMouseOverForecast = this.svg.selectAll(".rectMouseOverForecast").data(this.dataChartForecast).enter()
        .append("rect")
        .attr("class", "rectMouseOver rectMouseOverForecast").attr("x", (d, i)=>{
          return this.x(d.yearWeek)-this.x.step()/2
        })
        .attr("y", 0)
        .attr("width", (d, i)=>{
          return this.x.step()
        })
        .on("mouseover", (d)=>{
          this.lineCursor.style("opacity", 1);
          this.showDataInfo = true;

          
          if(this.$getCookie("language") == 'en'){
            _this.divInfoMonth = `${d.yearWeek.substring(0,4)} Week ${d.yearWeek.substring(4,6)}`;
            _this.divMappingWeekDay = _this.mappingWeekDay.find((d2)=>{return d2.yearWeek == d.yearWeek}).date;
            if(_this.simpleMode){
              _this.divInfoValue = `Forecast
              <ul>
                  <li class="Ensemble">${_this.getNumberofPeople(d.Ensemble)}</li>
              </ul>`;
            }
            else{
              _this.divInfoValue = `Forecast
              <ul>
                  <li class="Ensemble">${_this.getNumberofPeople(d.Ensemble)}</li>
                  <li class="ARIMA">${_this.getNumberofPeople(d.ARIMA)}</li>
                  <li class="RF">${_this.getNumberofPeople(d.RF)}</li>
                  <li class="SVR">${_this.getNumberofPeople(d.SVR)}</li>
                  <li class="XGB">${_this.getNumberofPeople(d.XGB)}</li>
              </ul>`;
            }
          }

          else{
            _this.divInfoMonth = `${d.yearWeek.substring(0,4)}年  ${d.yearWeek.substring(4,6)}週`;
            _this.divMappingWeekDay = _this.mappingWeekDay.find((d2)=>{return d2.yearWeek == d.yearWeek}).date;
            if(_this.simpleMode){
              _this.divInfoValue = `預估人次
              <ul>
                  <li class="Ensemble">${_this.getNumberofPeople(d.Ensemble)}</li>
              </ul>`;
            }
            else{
              _this.divInfoValue = `預估人次
              <ul>
                  <li class="Ensemble">${_this.getNumberofPeople(d.Ensemble)}</li>
                  <li class="ARIMA">${_this.getNumberofPeople(d.ARIMA)}</li>
                  <li class="RF">${_this.getNumberofPeople(d.RF)}</li>
                  <li class="SVR">${_this.getNumberofPeople(d.SVR)}</li>
                  <li class="XGB">${_this.getNumberofPeople(d.XGB)}</li>
              </ul>`;
            }
          }


          
          
          _this.lineCursor.attr("d", `M${_this.x(d.yearWeek)+_this.margin.left} 0 V280`);
        })
        .on("mousemove", function(d){
          _this.divInfoPath = 
          [d3.event.pageX-(_this.$refs.divChart.getBoundingClientRect().x || _this.$refs.divChart.getBoundingClientRect().left)-window.pageXOffset-100, 
          d3.event.pageY-(_this.$refs.divChart.getBoundingClientRect().y || _this.$refs.divChart.getBoundingClientRect().top)-window.pageYOffset+15]

          if(_this.divInfoPath[1] + 80 > _this.$refs.divChart.offsetHeight){
            _this.divInfoPath[1] -= 80
          }
        });

      this.svg.select(".rectMouseOverForecast").remove();

      this.svg.selectAll(".rectMouseOver")
        .attr("height", this.height - this.margin.bottom)
        .attr("transform", this.yTranslate)
        .attr("opacity", 0)
        .on("mouseleave", (d)=>{
          this.divInfoMonth = undefined;
          this.divInfoValue = undefined;
          this.divMappingWeekDay = undefined;
          this.showDataInfo = false;
          _this.lineCursor.style("opacity", 0);
        })

    },
    getNumberofPeople: function(val){
        return d3.format(",.0f")(val);
    },
    updateChart(){
      this.initXDomain();
      this.initYDomain();
    },
    changeSimpleMode(){
      if(this.simpleMode){
        this.svg.selectAll(".path_forecast,.text_forecast").attr("opacity", 0)
        this.svg.selectAll(".path_Ensemble,.text_Ensemble").attr("opacity", 1)
      }
      else{
        this.svg.selectAll(".path_forecast,.text_forecast").attr("opacity", 1)
      }
    }
  },
  watch:{
    simpleMode: function(){
      this.changeSimpleMode();
    }
  },
  mounted: function(){
    this.initChartComponent();
    this.initXDomain();
    this.initYDomain();
    this.appendLastValueToEnsemble();
    this.updateRealLine();
    this.updateForecastLine();
    this.updateEnsembleCircle();
    this.updateMouseOverEvent();
    this.changeSimpleMode();
  }
}
</script>

<style lang="scss">
    
    #divChart{
      width: 100%;
      height: 315px;
      position: relative;

      -moz-user-select: none;
      -webkit-user-select: none;
    }
    
    .axis {
      .domain, .tick>line {
        stroke: #cacaca;
      }
      .tick{
        text{
            font-size: 14px;
            fill: #848484;
        }
        .year{
          fill: #000;
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

    .path{
      fill: none;
      stroke-width: 2px;
      &.path_forecast {
        stroke:rgba(0, 0, 0, 0.35);
        stroke-dasharray: 4, 4;
        stroke-width: 3px;
      }
      &.path_Ensemble{
        //stroke:#E35959;
        stroke: #0714ef;
        stroke-width: 6px;
        stroke-dasharray: 5, 8;
      }
      &.path_real{
        stroke: #9E9E9E;
      }
      &.path_ARIMA{
        //stroke: rgba(32, 123, 180, .7);
        stroke: rgba(191, 10, 229, .7);
      }
      &.path_SVR{
        //stroke: rgba(247, 175, 34, .7);
        stroke: rgba(12, 209, 203, .7)
      }
      &.path_RF{
        //stroke: rgba(103, 186, 91, .7);
        stroke: rgba(209, 119, 11, .7);
      }
      &.path_XGB{
        //stroke: rgba(118, 194, 200, .7)
        stroke: rgba(143, 162, 242, .7);
      }
    }

    .circle_Ensemble{
      fill: #FFF;
      //stroke:#E35959;
      stroke: #0714ef;
      stroke-width: 2.5px;
    }

    .circle_Ensemble.first{
      stroke:#9E9E9E;
    }

    .lineCursor{
      stroke-width: 1;
      stroke: #9e9e9e;
    }

    #divDataInfo{
      position: absolute;
      pointer-events: none;
      opacity: 1;
      z-index: 2;
      transition: visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1);

      background-color: rgba(96, 125, 139, .90);
      border-radius: 4px;
      
      min-width: 80px;
      max-width: 160px;
      padding: 4px 8px;

      color: #FFF;

      .month,.mappingWeekDay{
        font-weight: bold;
        font-size: 14px;
      }

      .mappingWeekDay{
        font-size: 12px;
        padding-bottom: 4px;
        margin-top: 0px;
      }

      .value{
        font-size: 12px;
        ul{
          margin-bottom: 0px;
          list-style: none;
          padding: 0px;
          padding-left: 8px;
          padding-top: 4px;
          li::before{
            border-radius: 50%;
            content: "";
            display: inline-block;
            margin-right: 10px;
            margin-bottom: 2px;
            height: 10px;
            width: 10px;
          }
          li{
            padding-bottom: 2px;
            &.ARIMA::before {
              background-color: rgb(191, 10, 229);
            }
            &.SVR::before {
              background-color: rgb(12, 209, 203);
            }
            &.RF::before {
              background-color: rgb(209, 119, 11);
            }
            &.XGB::before {
              background-color: rgb(143, 162, 242);
            }
            &.Ensemble::before {
              //background-color: #E35959;
              background-color: #0714ef;
            }

          }
        }
      }
    }
</style>




// WEBPACK FOOTER //
// src/components/chartForecast.vue